import ReporteStockList from './ReporteStockList'
export {ReporteStockList}
export default ReporteStockList
